import React from "react";
import useGuideMediaManifestVersion from "../../hooks/useGuideMediaManifestVersion";
import { isPlannedGuideMedia, resolveGuideMediaEntry } from "../../utils/guideMediaPlanning";
import LazyVideo from "./LazyVideo";

const GuideMediaPlaceholder = ({
  entry,
  label,
  type = "image",
  plannedAssetPath,
  withFrame = true,
}) => {
  useGuideMediaManifestVersion();

  const resolvedEntry = resolveGuideMediaEntry(entry);
  const nextLabel = resolvedEntry?.label || entry?.label || label || "Guide media";
  const nextType = resolvedEntry?.type || entry?.type || type;
  const nextPlannedAssetPath =
    resolvedEntry?.plannedAssetPath || entry?.plannedAssetPath || plannedAssetPath || null;

  if (!isPlannedGuideMedia(resolvedEntry) && resolvedEntry?.src) {
    const mediaProps =
      resolvedEntry?.props && typeof resolvedEntry.props === "object" ? resolvedEntry.props : {};

    const content =
      nextType === "video" ? (
        <LazyVideo src={resolvedEntry.src} {...mediaProps} />
      ) : (
        <img src={resolvedEntry.src} alt={nextLabel} {...mediaProps} />
      );

    if (!withFrame) {
      return content;
    }

    return <div className="Image-Border">{content}</div>;
  }

  const content = (
    <div
      className={`guide-media-placeholder guide-media-placeholder--${nextType}`}
      role="note"
      aria-live="polite"
    >
      <span className="guide-media-placeholder__eyebrow">
        Planned {nextType === "video" ? "video" : "image"}
      </span>
      <strong className="guide-media-placeholder__title">{nextLabel}</strong>
      <p className="guide-media-placeholder__copy">
        This guide media is planned and will appear here once it has been produced.
      </p>
      {nextPlannedAssetPath ? (
        <code className="guide-media-placeholder__path">{nextPlannedAssetPath}</code>
      ) : null}
    </div>
  );

  if (!withFrame) {
    return content;
  }

  return <div className="Image-Border">{content}</div>;
};

export default GuideMediaPlaceholder;
